import walletProductDetailDialogMessages from '../../../messages/wallet/wallet-product-detail-dialog.messages';
import { Column } from '../../column';
import { UnitLinkedProductUnderlying } from '../details/product-underlying';

export const underlyingULColumns: Column<UnitLinkedProductUnderlying>[] = [
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingULPercentage,
    key: 'percentage',
    type: 'percentage',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingMediumPrice,
    key: 'averagePurchasePrice',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingAmount,
    key: 'quantity',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingMarketPrice,
    key: 'marketPrice',
    type: 'amount',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailUnderlyingULMarketPriceDate,
    key: 'marketPriceDate',
    type: 'date',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingCountervalue,
    key: 'equivalent',
    type: 'amount',
  },
];
